import React from "react";
import { ArrowRight, Star, Plane } from "lucide-react";
import { site } from "../mock";

const Hero = () => {
  return (
    <section className="relative overflow-hidden bg-gradient-to-b from-[#ffd7d4]/40 via-[#fbfaf6] to-[#fbfaf6] pt-32 pb-20 lg:pt-40 lg:pb-28">
      {/* decorative blobs */}
      <div className="pointer-events-none absolute -top-24 -right-24 h-96 w-96 rounded-full bg-[#ffd7d4]/50 blur-3xl" />
      <div className="pointer-events-none absolute top-40 -left-32 h-80 w-80 rounded-full bg-[#ff5a58]/10 blur-3xl" />

      <div className="relative max-w-7xl mx-auto px-6 grid lg:grid-cols-2 gap-14 items-center">
        <div className="reveal">
          <span className="inline-flex items-center gap-2 rounded-full bg-white/80 border border-[#efd9d1] px-4 py-1.5 text-xs font-500 uppercase tracking-[0.18em] text-[#86233a]">
            <Plane size={14} /> 24+ jaar reiservaring
          </span>
          <h1 className="font-display mt-6 text-[2.7rem] leading-[1.05] sm:text-6xl lg:text-[4.2rem] font-600 text-[#1d1c1a]">
            Jouw droomreis,
            <span className="block text-[#86233a] italic">van A tot Z geregeld.</span>
          </h1>
          <p className="mt-6 max-w-xl text-lg text-[#4b4642] leading-relaxed">
            Moe van eindeloos online zoeken naar de perfecte reis? Dat neem ik je
            volledig uit handen. Persoonlijk, professioneel en precies zoals jij
            het wilt. Geen stress, geen verrassingen.
          </p>

          <div className="mt-8 flex flex-wrap items-center gap-4">
            <a
              href="#contact"
              className="group inline-flex items-center gap-2 rounded-full bg-[#86233a] px-7 py-3.5 text-white font-500 hover:bg-[#530e2f] transition-colors duration-300 shadow-[0_8px_24px_rgba(134,35,58,0.28)]"
            >
              Plan je droomreis
              <ArrowRight size={18} className="transition-transform duration-300 group-hover:translate-x-1" />
            </a>
            <a
              href="#bestemmingen"
              className="inline-flex items-center gap-2 rounded-full border border-[#530e2f]/25 px-7 py-3.5 text-[#530e2f] font-500 hover:border-[#86233a] hover:bg-white transition-all duration-300"
            >
              Bekijk bestemmingen
            </a>
          </div>

          <div className="mt-10 flex items-center gap-3">
            <div className="flex -space-x-3">
              {["#86233a", "#ff5a58", "#530e2f"].map((c, i) => (
                <div key={i} className="h-9 w-9 rounded-full border-2 border-[#fbfaf6]" style={{ backgroundColor: c }} />
              ))}
            </div>
            <div>
              <div className="flex text-[#ff5a58]">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} size={15} fill="currentColor" />
                ))}
              </div>
              <p className="text-sm text-[#4b4642]">Beoordeeld met een <b>9,6</b> door reizigers</p>
            </div>
          </div>
        </div>

        {/* Image */}
        <div className="reveal relative">
          <div className="relative img-zoom rounded-[2rem] overflow-hidden shadow-[0_30px_60px_-15px_rgba(83,14,47,0.35)] ring-1 ring-white/60">
            <img
              src={site.photos.office}
              alt="Natascha van Dam, Travel Counsellor"
              className="w-full h-[420px] lg:h-[540px] object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#530e2f]/25 to-transparent" />
          </div>
          <div className="absolute -bottom-6 -left-6 bg-white rounded-2xl shadow-xl px-6 py-4 hidden sm:block">
            <p className="font-display text-2xl text-[#86233a]">Natascha</p>
            <p className="text-xs uppercase tracking-[0.2em] text-[#4b4642]">Travel Counsellor</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
